import React from 'react';
import { useTranslation } from 'react-i18next';
import AccordanceTooltip from './AccordanceTooltip';

type SubstantialFundamentalChange = {
  id: number;
  nameSubstantialFundamentalChanges: string;
};

type Props = {
  accordancesSubstantialFundamentalChanges?: SubstantialFundamentalChange[];
  urlPMB?: string;
};

const AccordanceModificationInfoSection = ({ accordancesSubstantialFundamentalChanges, urlPMB }: Props) => {
  const { t } = useTranslation();
  const urlPMBDecoded = decodeURIComponent(decodeURIComponent(urlPMB || ''));

  return (
    <>
      <div className="horizontal-row title-horizontal">{t('modification_info').toUpperCase()}</div>

      <div className="accordance-detail-column-block">
        <div className="accordance-detail-inline-header">
          <p className="accordance-detail-text-sm">{t('substantial_fundamental_changes')}</p>
          <AccordanceTooltip
            title={t('substantial_fundamental_changes')}
            panelClassName="substantial-detail-tooltip"
            children={
              <>
                <p className="accordance-detail-tooltip-text pb-1">{t('substantial_fundamental_description')}</p>
                <a
                  href="https://idbg.sharepoint.com/teams/ez-LEG/Regulations/Current%20Regulations/ENG/OA-430%20Substantial%20and%20Fundamental%20Changes%20to%20Operations.pdf?isSPOFile=1&xsdata=MDV8MDJ8fGFmZWZkNzZlMmYwNTQ2YTBhMTE0MDhkZTc2MjJmZWM2fDlkZmIxYTA1NWYxZDQ0OWE4OTYwNjJhYmNiNDc5ZTdkfDB8MHw2MzkwNzgwODk4MDg1ODQ5ODB8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKRFFTSTZJbFJsWVcxelgwRlVVRk5sY25acFkyVmZVMUJQVEU5R0lpd2lWaUk2SWpBdU1DNHdNREF3SWl3aVVDSTZJbGRwYmpNeUlpd2lRVTRpT2lKUGRHaGxjaUlzSWxkVUlqb3hNWDA9fDF8TDJOb1lYUnpMekU1T2prMFlXRTBPRE5pTFRCaVptWXROR0UyTkMwNU56WTFMVEkyWXpZMk9XWmhORFUzWmw5a1lXTmhObUUwTmkxbFlqa3lMVFF4TnpVdE9EY3hPUzFrTkRVME56VTBNVFl4Tm1SQWRXNXhMbWRpYkM1emNHRmpaWE12YldWemMyRm5aWE12TVRjM01qSXhNakUzT1RZNE1BPT18MmU3YjBkMjU4NmVmNDVhODA0NzUwOGRlNzYyMmZlYzZ8YjgxMWM4MzUxNzYxNDQ3Yzk1NWViYjJlMzEzMzZmYTY%3D&sdata=Z2xIYnhXMFd2RUZ0YWl2eHN4UlIrQlZhWjhJbmZnMGRHNzJnOWYyVjMwQT0%3D&ovuser=9dfb1a05-5f1d-449a-8960-62abcb479e7d%2CJULIANME%40IADB.ORG"
                  target="_blank"
                  rel="noopener noreferrer"
                >{`${t('to_open')} OA-430`}</a>
              </>
            }
          />
        </div>

        {(accordancesSubstantialFundamentalChanges ?? []).map((changes) => (
          <p className="accordance-detail-text-md" key={changes.id}>
            {changes.nameSubstantialFundamentalChanges}
          </p>
        ))}
      </div>

      <div className="accordance-detail-column-block accordance-detail-column-block--mt-sm">
        <div className="accordance-detail-inline-header">
          <p className="accordance-detail-text-sm">{t('project_modification_brief')}</p>
          <AccordanceTooltip
            title={t('project_modification_brief')}
            panelClassName="substantial-detail-tooltip"
            children={
              <>
                <p className="accordance-detail-tooltip-text pb-1">{t('project_modification_brief_description')}</p>
              </>
            }
          />
        </div>

        <a className="accordance-detail-link-file" target="_blank" href={urlPMBDecoded}>
          {urlPMBDecoded}
        </a>
      </div>
    </>
  );
};

export default AccordanceModificationInfoSection;
